// extracted by mini-css-extract-plugin
export default {"container":"clientSettlements_container__emADV","iconBox":"clientSettlements_iconBox__883NC","header":"clientSettlements_header__Rcnma"};